const checkUserThemeCompanyPermission = (role, text, connected) => {
  if (text === "Add to theme") {
    if (!connected || role === "viewer") {
      return true;
    }
  }
  return false;
};
export default checkUserThemeCompanyPermission;
